import React from 'react';

/**
 * "My locations | All locations" -- the Documents page's on-page control for
 * issue #17's ?scope= filter. Deliberately NOT a hierarchy picker: unlike
 * StatusMultiSelect (a fixed enum) or the applicability/policy-area
 * multiselects, there is nothing here to fetch, and this page has never had
 * an on-page hierarchy control at all (hierarchy_node_id only ever arrives
 * via a dashboard deep link, per DocumentsPage's own comments) -- this is a
 * two-state preference, not a location picker.
 *
 * Two plain pill buttons rather than a new toggle-switch component: this repo
 * has no existing segmented-control primitive, and btn-primary/btn-secondary
 * already read as "selected/not selected" everywhere else in the app.
 */
export function scopeFromParams(searchParams, hasHomeScope) {
  const explicit = searchParams.get('scope');
  if (explicit === 'mine' || explicit === 'all') return explicit;
  // Absent means the page's own default, same rule ?status= follows (#36):
  // a user with something set defaults to seeing their own; a user with
  // nothing set has no default to apply, so 'all' is the only sane answer --
  // the alternative would silently look like an empty document list.
  return hasHomeScope ? 'mine' : 'all';
}

function ScopeToggle({ value, onChange, hasHomeScope }) {
  return (
    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
      <button
        type="button"
        className={`btn btn-small ${value === 'mine' ? 'btn-primary' : 'btn-secondary'}`}
        onClick={() => onChange('mine')}
        disabled={!hasHomeScope}
        title={hasHomeScope ? undefined : 'No default location set -- ask an administrator, or set one on your Profile page'}
      >
        📍 My locations
      </button>
      <button
        type="button"
        className={`btn btn-small ${value === 'all' ? 'btn-primary' : 'btn-secondary'}`}
        onClick={() => onChange('all')}
      >
        🌐 All locations
      </button>
    </div>
  );
}

export default ScopeToggle;
